var map = {
	"./computer/Token/TokenDetail.vue": [
		"2b39",
		"chunk-c21f4bdc"
	],
	"./mobile/Token/TokenDetail.vue": [
		"4824",
		"chunk-f9745130"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "3e8b";
module.exports = webpackAsyncContext;